"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "constructSymbilityDeepLink", {
    enumerable: true,
    get: function() {
        return constructSymbilityDeepLink;
    }
});
const _url = require("./url");
const constructSymbilityDeepLink = (baseUri, claimNumber)=>{
    if (claimNumber.includes('-')) {
        claimNumber = claimNumber.substring(0, claimNumber.lastIndexOf('-'));
    }
    return (0, _url.combinePaths)(baseUri, `/ux/site/#/claims;quickSearch=${claimNumber}`);
};

//# sourceMappingURL=construct-deep-links.js.map